module.exports = __webpack_public_path__ + "static/media/5_7.b7fbe648.jpg";